import { outdent } from 'outdent';
import type { DevCenterComponent } from '../../../dev-center/components/dev-center-component.js';
import {
  getCustomElementPathWithHMR,
  getComponentPathWithHMR,
} from '../hmr/plugin.js';

const getCustomElementBaseTemplate = (
  path: string,
  tagName: string,
  appId: string
) =>
  // In UsersCustomElementClass we have class that will be registered in customElements registry
  // Then this class will be used to create instances for each of elements of our CustomElement
  // That's why we patching it's proto with accessTokenListener (in case user do not have it), so then platform could call it on each of instances
  outdent`
  import { enableClient } from "@wix/cli-app/internal/platform-sdk/site";
  (async function () {
    if (!window['React']) {
      await import('https://static.parastorage.com/unpkg/react@16.14.0/umd/react.production.min.js');
      await import('https://static.parastorage.com/unpkg/react-dom@16.14.0/umd/react-dom.production.min.js');
    }
    const { default: UsersCustomElementClass } = await import('${path}');

    let accessTokenListenerFn = UsersCustomElementClass.prototype.accessTokenListener;
    if (!accessTokenListenerFn) {
      const { injectGetAccessToken } = enableClient('${appId}');
      accessTokenListenerFn = injectGetAccessToken;
    }
    Object.defineProperty(UsersCustomElementClass.prototype, 'accessTokenListener', {
      writable: false,
      configurable: false,
      value: accessTokenListenerFn
    });

    customElements.define('${tagName}', UsersCustomElementClass);
  })();
`;

export const getCustomElementDevTemplate = (
  appId: string,
  base: string,
  customElementComponent: DevCenterComponent<'CustomElement' | 'SitePlugin'>
) => {
  return getCustomElementBaseTemplate(
    getCustomElementPathWithHMR(base, customElementComponent),
    customElementComponent.tagName,
    appId
  );
};

export const getCustomElementBuildTemplate = (
  appId: string,
  customElementComponent: DevCenterComponent<'CustomElement' | 'SitePlugin'>
) => {
  return getCustomElementBaseTemplate(
    `/${customElementComponent.relativePath}`,
    customElementComponent.tagName,
    appId
  );
};

export const getCustomElementPanelDevTemplate = (
  customElementPanelComponent: DevCenterComponent<
    'CustomElement' | 'SitePlugin'
  >
) => {
  return outdent`
    import { enableClient } from '@wix/cli-app/internal/platform-sdk/editor';
    enableClient();
    export { default } from '${getComponentPathWithHMR(
      customElementPanelComponent.relativePanelPath!
    )}';
  `;
};

export const getCustomElementPanelBuildTemplate = (
  customElementPanelComponent: DevCenterComponent<
    'CustomElement' | 'SitePlugin'
  >
) => {
  return outdent`
    import { enableClient } from '@wix/cli-app/internal/platform-sdk/editor';
    enableClient();
    export { default } from '/${customElementPanelComponent.relativePanelPath}';
  `;
};
